/**
 * Created by Ning Jiang on 10/31/2017.
 */

import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {NudgeSpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelPartAnimator";
import {BurningWildReelSymbol} from "../../reelsymbol/BurningWildReelSymbol";

export class WildNudgeNudgeReelPartAnimator extends NudgeSpinReelPartAnimator {

    constructor(reelId:number) {
        super(reelId);
    }

    public initSymbols(symbols:StateReelSymbol[]):void {
        for(let i:number = GameConfig.instance.SYMBOLS_NUM_IN_REEL[0] + GameConfig.instance.SYMBOLS_NUM_IN_REEL[1]; i < symbols.length; i++) {
            if(symbols[i].stackedSymName!.symName === "W" || symbols[i].stackedSymName!.symName.substr(0, 1) === "M") {
                (<BurningWildReelSymbol>symbols[i]).stack!.noMoreFire = true;
                (<BurningWildReelSymbol>symbols[i]).stack!.isPlayingFire = false;
            }
        }
        super.initSymbols(symbols);
    }


}